<template>
  <h1>Profile Component</h1>
</template>

<script lang="ts" setup></script>
